const controllers = new Map()

const getController = (key = '') => {
    if (key && controllers.has(key)) {
        controllers.get(key).abort()
    }

    const controller = new AbortController()

    if (key) {
        controllers.set(key, controller)
    }

    return controller
}

const cancel = (key) => {
    const controller = controllers.get(key)
    if (controller) {
        controller.abort()
        controllers.delete(key)
    }
}

const cancelAll = () => {
    controllers.forEach((controller) => controller.abort())
    controllers.clear()
}

export { getController, cancel, cancelAll }
